module.exports = __webpack_public_path__ + "img/Rectangle 4.746fb8eb.png";